import { Component, OnInit, Input, TemplateRef, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SweetAlertResult } from "sweetalert2";

import { SharedService } from "@services/shared.service";
import { ApiTransactionService } from "@services/api-transaction.service";
import { ApiAccountService } from "@services/api-account.service";

import { CustomerModel } from "@models/CustomerModel";
import { CustomerCardModel } from "@models/CardModel";
import { BuyerType, TransactionModel, ProductOrderModel, NewTransactionPackageModel } from "@models/TransactionModel";
import { CardPaymentModel } from "@models/RegisterModel";
import { CardFormComponent } from '@components/card-form/card-form.component';
import { ProductTaxType, PayType, OrderStatus, PointTransactionType, CurrencyType, CardIssueType, Country } from "@models/Enums";

import { ModalFormBase } from "@shared/modal-base.component";

import { envVariables } from "@shared/mock-data";
import { Constants } from "@shared/shared.constants";
import { SessionManager } from "@services/session-manager";
import { PackageModel } from '@shared/models/PackageModel';

@Component({
    selector: 'app-purchase-package-modal',
    templateUrl: './purchase-package-modal.component.html',
    styleUrls: ['./purchase-package-modal.component.scss']
})
export class PurchasePackageModalComponent extends ModalFormBase<NewTransactionPackageModel> implements OnInit {

    @Input() user: CustomerModel;
    @Input() package: PackageModel;
    @Input() uniqueLinkCode: string = null;
    @Input() sendRequestVerification = false;
    @ViewChild("purchaseModal", { static: true }) modal: TemplateRef<any>;

    model: NewTransactionPackageModel;

    // form


    methods: CustomerCardModel[] = [];
    currentMethod: CustomerCardModel;

    selectedMethod = "";

    // País de la sesión: define la pasarela con la que se agrega la tarjeta
    country: Country = Country.CR;

    newCard: CardPaymentModel;
    requireInvoice = false;

    //accordion flags
    paymentMethodAccordion = false;
    pointsAccordion = false;

    benefitText: string = '';

    requireVerification = false;
    // Validate verification
    issueTypes: { type: CardIssueType }[] = [];
    issues: any[] = [];
    customerCards: CustomerCardModel[] = [];
    transactionIssue: TransactionModel;

    assignedSuccess = false;

    constructor(
        private router: Router,
        public sharedService: SharedService,
        public modalService: NgbModal,
        private apiAccountService: ApiAccountService,
        private apiTransactionService: ApiTransactionService
    ) {
        super(modalService);
    }

    ngOnInit() {

        this.country = SessionManager.getSession(true)?.user?.country ?? Country.CR;

        this.benefitText = this.package.packageBenefits.map(benefit => benefit.data?.name).join(' - ')
        this._checkPurchasesVerification();
    }

    onOpen() {

        if (!this.user) {
            return this.sharedService.SwalCustom.fire({
                title: "Iniciar sesión",
                text: "Para comprar el Givi POPs debe iniciar sesión.",
                showCancelButton: true,

                cancelButtonText: "Cancelar",
                confirmButtonText: "Iniciar sesión",

                allowOutsideClick: false,

                customClass: {
                    confirmButton: "btn btn-modal-main",
                    cancelButton: "btn btn-modal-second",
                },
                buttonsStyling: false,
            }).then((result: SweetAlertResult) => {
                if (result && result.value) {
                    this.router.navigate(["login"]);
                }
            });
        }



        // Refresh the UI
        setTimeout(() => window.scrollTo({ top: 0 }), 100);

        this._getPaymentMethods();

        this.onNext();

        super.open(this.modal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-content-full",
        });
    }

    onShowGetPoints() {
        this.onClose();
        this.sharedService.setShowGetPointsModal(true);
    }

    onClose() {
        super.close();
    }

    onCloseSucess() {
        this.assignedSuccess = false;
        this.sharedService.setGiftcardForModal(null);

    }

    // cuando se selecciona el giftcard y va al resumen de pago
    private onNext() {

        this.model = new NewTransactionPackageModel({
            vendorId: this.package.vendorId,
            buyerType: BuyerType.Customer,
            customerId: this.user.id,

            subTotal: this.package.price,
            taxTotal: 0, // No tiene IVA
            total: this.package.price + (this.package.price * (this.package.customerCommissionPercent / 100)) + this.package.costTransaction,

            // Commission
            customerCommissionPercent: this.package.customerCommissionPercent,
            vendorCommissionPercent: this.package.vendorCommissionPercent,

            points: 0,
            pointsValue: envVariables[Constants.ENV_POINTS_VALUE_KEY] ?? 1,

            products: [
                new ProductOrderModel({
                    productId: this.package.id,
                    productName: this.package.name,
                    productImageId: 0,

                    quantity: 1,
                    // points: this.package.points,

                    price: this.package.allowDiscount
                        ? this.package.priceWithDiscount
                        : this.package.price,
                    tax: 0, // No tiene IVA
                    taxType: ProductTaxType.Exempt,
                    taxPercent: 0,
                    // totalPrice: product.price
                    currencyType: CurrencyType.CRC,
                    // Precio proveedor
                    vendorPrice: this.package.vendorPrice,
                    vendorPriceWithTax: this.package.vendorPriceWithTax,
                    // Precio a Givi
                    vendorDiscountType: this.package.vendorDiscountType,
                    vendorPriceWithDiscount:
                        this.package.vendorPriceWithDiscount,

                    // Commission
                    customerCommissionPercent: this.package.customerCommissionPercent,
                    vendorCommissionPercent: this.package.vendorCommissionPercent,
                }),
            ],
        });

        if (this.package.price == 0) this.model.total = 0;
        if (this.package.communityId > 0) this.model.communityId = this.package.communityId;
        if(this.uniqueLinkCode) this.model.uniqueLinkCode = this.uniqueLinkCode;

        this._formInit();
    }

    onSelectMethod(card: CustomerCardModel, toggleAccordion: number) {
        this.currentMethod = card;
        this.onToggleAccordion(toggleAccordion);
        //modal.dismiss();
    }

    @ViewChild(CardFormComponent) cardFormComponent: CardFormComponent;

    // La tarjeta la arma app-card-form y llega por (cardChange). null = incompleta.
    onCardChange(card: CardPaymentModel) {

        this.newCard = card;
    }

    onSaveCard(modal: any): void {

        if (!this.newCard) return;

        this.newCard.companyId = this.user.id;

        if (this.cardFormComponent?.isAmexCVC) {
            const errMsg =
                "No se aceptan tarjetas American Express. Por favor revisá la información y volvé a intentarlo.";
            this.sharedService.showErrorAlert(null, errMsg);
        } else {
            this.sharedService.setLoading(true);

            this.apiAccountService.addCard(this.newCard).then(
                (data: any) => {
                    this.sharedService.setLoading(false); // hide loader

                    this._getPaymentMethods();

                    this.sharedService
                        .showSuccessAlert(
                            null,
                            `La tarjeta fue agregada correctamente`
                        )
                        .then((_) => modal.dismiss());
                },
                (err: any) => {
                    this.sharedService.setLoading(false); // hide loader

                    const errMsg =
                        "No se pudo agregar la tarjeta. Por favor revisá la información y volvé a intentarlo.";
                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    onCreateCard(paymentMethodModal: any) {
        this.newCard = null;

        this.modalService.open(paymentMethodModal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-full",
        });
    }

    onOpenMethods(paymentMethodModal: any) {
        this.modalService.open(paymentMethodModal, {
            backdrop: "static",
            keyboard: false,
            windowClass: "modal-dialog-end modal-full",
        });
    }

    onPay() {

        if (this.model && (this.currentMethod || this.model.total == 0)) {

            this.model.cardToken = this.currentMethod?.token;

            if (this.model.points > 0) {
                this.model.payType = PayType.CardPoints;
            } else {
                this.model.payType = PayType.Card;
            }

            this.sharedService.setLoading(true);

            if(this.uniqueLinkCode != null) this.model.uniqueLinkCode = this.uniqueLinkCode;

            this.apiTransactionService.payOrderPackage(this.model).then(
                (order: any) => {
                    const year = new Date().getFullYear();

                    const transaction = new TransactionModel({
                        id: order.id,

                        type: PointTransactionType.PurchaseGiftcards,

                        buyerType: BuyerType.Customer,
                        buyerId: this.user.id,
                        customer: this.user,

                        addressDetails: order.addressDetails,
                        createdAt: new Date(),
                        paymentAt: new Date(),
                        orderStatus: OrderStatus.PaidOrExchanged,

                        subTotal: this.model.subTotal,
                        taxTotal: 0, // No tiene IVA
                        total: this.model.total,

                        points: 0,

                        expirationAt: new Date(year, 11, 31),
                    });

                    this.apiTransactionService.loadAccount().then(

                        (user: CustomerModel) => {

                            this.sharedService.setLoading(false);
                            this.modalService.dismissAll();

                            this.assignedSuccess = true;
                        },
                        err => {
                            this.sharedService.setLoading(false);
                            this.modalService.dismissAll();
                        }
                    );
                },
                (err: any) => {
                    this.sharedService.setLoading(false);

                    let errMsg = "";

                    if (
                        err.error?.Message != null &&
                        err.error?.Message != ""
                    ) {
                        errMsg = err.error?.Message;
                    } else {
                        errMsg =
                            "No se pudo realizar la compra. Por favor revisá la información y volvé a intentarlo.";
                    }

                    this.sharedService.showErrorAlert(null, errMsg);
                }
            );
        }
    }

    // Form

    onToggleAccordion(accordionType) {
        if (accordionType == 2) {
            this.paymentMethodAccordion = !this.paymentMethodAccordion;
        } else {
            if (this.pointsAccordion) {
                /*  this.model.points = 0;
                this.model.total = this.model.subTotal; */
            }
            this.pointsAccordion = !this.pointsAccordion;
        }
    }

    onReceivePointsSelected(receivedPoints: number) {
        //total points
        this.model.points = receivedPoints;
        // discount in colones
        this.model.pointsDiscount = receivedPoints * this.model.pointsValue;
        //total with the discount
        this.model.total = (this.model.subTotal + (this.model.subTotal * (this.package.customerCommissionPercent / 100)) + this.package.costTransaction) - this.model.pointsDiscount;
    }

    private _formInit(): void {
        this.requireInvoice = false;

        // Reset for hide form errors
        this.touched = true;
    }

    // End Form

    private _getPaymentMethods(showSpinner = true): Promise<void | CustomerCardModel[]> {

        // No hacer la llamada si no esta logueado
        if (!this.user) return;

        if (showSpinner) this.sharedService.setLoading(true);

        return this.apiAccountService.getAllCards(this.user.id).then(
            (cards: CustomerCardModel[]) => {

                this.currentMethod = cards.find((x) => x.isCurrent);
                if (this.currentMethod) {
                    this.selectedMethod = this.currentMethod.token;
                }

                this.methods = cards; // update the source

                if (showSpinner) this.sharedService.setLoading(false);

                return cards;
            },
            (err: any) => {

                if (showSpinner) this.sharedService.setLoading(false);
                Promise.reject(err);
            }
        );
    }

    private _checkPurchasesVerification(): void {

        this.sharedService.setLoading(true);

        const session = this.apiTransactionService.getSession();

        // Verificar si los givis comprados infringen algún trigger de fraude
        const myGivis = SessionManager.getMyGivis();
        const issues = session.verifyGiviIssues(myGivis);
        this.requireVerification = issues?.length > 0;

        this.apiAccountService.getAllCards(session.user.id)
            .then((customerCards: CustomerCardModel[]) => {

                // Si se requiere verificación  y el usuario tiene tarjeta
                if (this.sendRequestVerification && this.requireVerification && customerCards?.length > 0) {

                    // Obtener la compra mas reciente
                    const recentGivis = myGivis.sort((a, b) => b.id - a.id);

                    const cardIssues: { token: string; customerCard: CustomerCardModel, type: CardIssueType }[] = [];

                    // por cada caso, buscar los únicos por tarjeta
                    issues.forEach(issue => {

                        const givi = recentGivis.find(x => x.id == issue.giviId);
                        if (givi && cardIssues.findIndex(x => x.token == givi.cardToken) < 0) {
                            const customerCard = customerCards.find(x => x.token == givi.cardToken);
                            if (customerCard) {
                                // Si la tarjeta no esta verificada y aun no tiene casos según triggers de fraude
                                if (!customerCard.verifiedAt && !customerCard.issues?.length) {

                                    cardIssues.push({
                                        token: customerCard.token,
                                        customerCard: customerCard,
                                        type: issue.type
                                    });
                                }
                            }
                        }
                    });

                    // por cada tarjeta del usuario
                    cardIssues.forEach(customerCardIssue => {

                        // Buscar la tarjeta según el caso
                        const customerCard = customerCards.find(x => x.token == customerCardIssue.token);
                        if (customerCard) {

                            // Solo se agrega si la tarjeta no tiene el tipo de caso abierto
                            if (customerCard.issues?.some(x => x.type == customerCardIssue.type && x.verifiedAt == null) == false) {
                                // Crear caso de verificación de tarjeta
                                this.apiTransactionService.requestCardVerification(customerCardIssue.customerCard, customerCardIssue.type);
                            }
                        }
                    });
                }

                if (this.requireVerification) {

                    this.customerCards = customerCards;
                    this.issues = issues;
                    this._createIssueTransaction();
                }

                this.sharedService.setLoading(false);
            }).catch(err => {

                this.sharedService.setLoading(false);

                let errMsg = `Error al cargar información del Givi.`;
                if (err.status == 404) {
                    errMsg = `El Givi no existe.`;
                }
                // Desautorizado navigate to login
                else if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                        this.router.navigate(['/market']);
                    });
                    return;
                }
                this.sharedService.showErrorAlert(null, errMsg);
            });
    }

    private _createIssueTransaction() {

        if (this.requireVerification) {

            this.transactionIssue = new TransactionModel();
            // Obtiene el issue mas reciente
            var issue = this.issues?.[this.issues.length - 1];

            this.transactionIssue.id = issue?.giviId;
            const customerCard = this.customerCards?.find(x => x.token === issue?.token) || new CustomerCardModel();
            this.transactionIssue.customerCard = customerCard;
        }
    }

    verifyCard() {

        if (this.requireVerification) {

            this.sharedService.setShowVerifyCardModal(this.transactionIssue);
        }
    }

}
